import { render, staticRenderFns } from "./OffersTop.vue?vue&type=template&id=03a88765&scoped=true"
import script from "./OffersTop.vue?vue&type=script&lang=js"
export * from "./OffersTop.vue?vue&type=script&lang=js"
import style0 from "./OffersTop.vue?vue&type=style&index=0&id=03a88765&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a88765",
  null
  
)

export default component.exports